import React, { useContext } from "react";

// Material UI imports
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import FormControl from "@material-ui/core/FormControl";

// Global state
import { StateContext } from "../../AppStateContext";

const AddClassPropertyModalAdvancedSettingsContent = ({
  isClassAdvancedSettingsModalOpen,
  setIsClassAdvancedSettingsModalOpen,
  propObj,
  setPropObj,
}) => {
  const state = useContext(StateContext);

  return (
    <FormControl component="fieldset">
      <FormGroup aria-label="position" row>
        <label
          htmlFor="vectorizePropertyNameCheckbox"
          value="Vectorize Property Name"
          style={{
            color: state.theme === "dark" ? "#e2e9ff" : "#00152b",
            fontWeight: "200",
            fontFamily: "Alegreya Sans, sans-serif !important",
            fontSize: "18px",
            marginTop: "11px",
            marginLeft: "11px",
            marginRight: "30px",
          }}
        >
          Vectorize Property Name
        </label>{" "}
        <Checkbox
          style={{ color: "fa0171" }}
          id="vectorizePropertyNameCheckbox"
          value={propObj.vectorizePropName}
          onChange={(e) =>
            setPropObj({ ...propObj, vectorizePropertyName: e.target.checked })
          }
        />
      </FormGroup>
      <FormGroup aria-label="position" row>
        <label
          htmlFor="indexPropertyCheckbox"
          value="Vectorize Property Name"
          style={{
            color: state.theme === "dark" ? "#e2e9ff" : "#00152b",
            fontWeight: "200",
            fontFamily: "Alegreya Sans, sans-serif !important",
            fontSize: "18px",
            marginTop: "11px",
            marginLeft: "12.5px",
            marginRight: "170px",
          }}
        >
          Index
        </label>{" "}
        <Checkbox
          style={{ color: "fa0171" }}
          id="indexPropertyCheckbox"
          value={propObj.index}
          onChange={(e) => setPropObj({ ...propObj, index: e.target.checked })}
        />
      </FormGroup>
    </FormControl>
  );
};

export default AddClassPropertyModalAdvancedSettingsContent;
